// extracted by mini-css-extract-plugin
export default {"trigger":"AppointmentStatusBadgeMenu_trigger__SUpBn"};